import React, {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import FilterAnimal from "./FilterAnimal";
import {genderList, quantityList} from "./lists";
import PopupEditAnimal from "./PopupEditAnimal";
import PopupDeleteAnimal from "./PopupDeleteAnimal";
import PopupExportBoleto from "../../Boletos/Components/PopupExportBoleto";
import PopupExportAnimal from "./PopupExportAnimal";
import {useUser} from "../../../auth/AuthProvider";
import AnimalActions from "./AnimalActions";

export default function AnimalList({
                                       baseUrl, loadData,
                                       setLoadData, size, page,
                                       setTotalPages, setTotalElements,
                                       sort, setSort, updateCode, setPage
                                   }) {

    const {user} = useUser()

    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [filter, setFilter] = useState({})

    const titles = [
        'Número do Lote',
        'Nome',
        'Documento',
        'Gênero',
        'Quantidade'
    ]

    console.log(data);

    return (
        <>
            <FilterAnimal filter={filter} setFilter={setFilter} setLoadData={setLoadData} setPage={setPage}/>
            {/*<PopupAddAnimal baseUrl={baseUrl} setLoadData={setLoadData}/>*/}
            <TableList
                titles={titles} baseUrl={baseUrl + '/list'}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{item.pedido.numero}</td>
                        <td>{item.nomeAnimal}</td>
                        <td>{item.documento}</td>
                        <td>{genderList.filter(qtt => qtt.value === item.generoAnimal)[0].label}</td>
                        <td>{quantityList.filter(qtt => qtt.value === item.quantidade)[0].label}</td>
                        <td>
                            <AnimalActions setLoadData={setLoadData} item={item} baseUrl={baseUrl}/>
                        </td>
                    </tr>
                )}
            </TableList>
            <br/>
            {user?.isAdmin &&
                <PopupExportAnimal filter={filter}/>
            }
        </>
    )
}